var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-product-container"},[_c('div',{staticClass:"my-product-publish-btn",on:{"click":function($event){return _vm.clickPublishProductBtnHandler()}}},[_c('p',{staticClass:"my-product-publish-btn-text"},[_vm._v("我要卖号")])]),_c('product-item')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }